import axios, { AxiosError } from 'axios';
import * as React from 'react';
import { requestGeneralSettings } from '../asyncHelpers/settingsService';
import { RequestStatus } from '../sic-lib/enums/RequestStatus';
import { TimeZoneSettings } from '../sic-lib/types/GeneralSettings';
import { useAppDispatch } from '../store/hooks';
import { createToast } from '../store/notify';
import { createErrorToast } from '../utils/notifyHelpers';

/**
 * useAsyncRequestGeneralSettings
 *
 * @description
 * React hook providing request state management and cancellation for the
 * requestGeneralSettings HTTP request
 */
export default function useAsyncRequestGeneralSettings() {
    const dispatch = useAppDispatch();
    const request_token = axios.CancelToken.source();

    React.useEffect(() => {
        return () => {
            request_token.cancel();
        };
    }, []);

    const [requestStatus, setRequestStatus] = React.useState<RequestStatus>(RequestStatus.none);

    const asyncRequestGeneralSettings = async (settings: {}): Promise<
        [TimeZoneSettings] | undefined
    > => {
        try {
            setRequestStatus(RequestStatus.active);

            const { data } = await requestGeneralSettings(settings, request_token.token);

            setRequestStatus(RequestStatus.success);

            return data;
        } catch (e: any) {
            if (!axios.isCancel(e)) {
                if (axios.isAxiosError(e)) {
                    const error = e as AxiosError;
                    if (e.response?.status == 400) {
                        /* Notify user of failed http request */
                        const toastData = createErrorToast(e.response.data);

                        dispatch(createToast({ toastData }));
                    }
                }
                /* Update state */
                setRequestStatus(RequestStatus.error);
            }
        }
    };

    return {
        requestStatus,
        asyncRequestGeneralSettings,
    };
}
